import { render, staticRenderFns } from "./EstablishProduct.vue?vue&type=template&id=036731fa&scoped=true&"
import script from "./EstablishProduct.vue?vue&type=script&lang=js&"
export * from "./EstablishProduct.vue?vue&type=script&lang=js&"
import style0 from "./EstablishProduct.vue?vue&type=style&index=0&id=036731fa&lang=scss&scoped=true&"
import style1 from "./EstablishProduct.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036731fa",
  null
  
)

export default component.exports